

function getCookie(name) {
  let matches = document.cookie.match(new RegExp(
    "(?:^|; )" + name.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, '\\$1') + "=([^;]*)"
  ));
  return matches ? decodeURIComponent(matches[1]) : undefined;
}

// actions menu
document.addEventListener('DOMContentLoaded', ()=> {
  const menuWrapper = document.querySelector('.menu-drawer-container')
  const tabs = document.querySelectorAll('.list-menu-gender .item-menu-gender');
  const menus = document.querySelectorAll('.menu-content');
  const itemsMenu = document.querySelectorAll('span.menu-item')
  const btnBack = document.querySelectorAll('#btn-back')
  const btnsClose = document.querySelectorAll('.btn-close')
  const btnsAll = document.querySelectorAll('.all-menu-item')
  const menuBottom = document.querySelector('.bottom-menu')
  const ctnFeatureCollection = document.querySelectorAll('.container-featured-collection')
  const imgFeatureCollection = document.querySelectorAll('.container-featured-collection img')

  document.querySelectorAll('.sub-item a[data-value], .sub-sub-item a[data-value]').forEach(function(element) {
    element.addEventListener('click', function(event) {
        event.preventDefault();
        const gender = this.getAttribute('data-value');
        document.cookie = "gender" + '=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
        //expiracion de cookie en una semana
        const currentDate = new Date();
        currentDate.setTime(currentDate.getTime() + (7 * 24 * 60 * 60 * 1000));
        const expires = "expires=" + currentDate.toUTCString();

        document.cookie = "gender=" + gender + "; path=/; " + expires;
        window.location.href = this.href;
    });
});
  const showMenu = (menuId) => {
    console.log("menuId", menuId)
    if(menuId == "women"){
      menuId = "mujer";
    }
    const item = document.querySelector(`[data-menu=${menuId}]`);
    tabs.forEach(tab => {
      tab.classList.remove('item-menu-gender--active')
    })
    item.classList.add('item-menu-gender--active')
    menus.forEach(menu => {
        menu.style.display = 'none';
    });
    document.getElementById(menuId).style.display = 'block';
  }

  if(getCookie("gender") !== undefined && getCookie("gender") !== ""){
    const gender = getCookie("gender")
    showMenu(gender)
  }else{
    showMenu("mujer")
  }
  btnsClose.forEach(btnClose =>{
    btnClose.addEventListener("click", ()=>{
      
      menuWrapper.classList.remove('menu-opening')
      menuWrapper.removeAttribute('open')
      menuWrapper.querySelector('summary').setAttribute('aria-expanded', false)
      document.body.classList.remove(`overflow-hidden-desktop`);
    })
  })

  tabs.forEach(tab => {
    tab.addEventListener('click', () => {
      
          const menuId = tab.getAttribute('data-menu');
          showMenu(menuId);
      });
  });
  menus.forEach(menu => {
    menu.addEventListener('mouseover', () => {
        menu.style.display = 'block';
      });
  });

  itemsMenu.forEach(itemMenu => {
    itemMenu.addEventListener('click', () => {
      menuBottom.style.display = 'none';
      const itemId = itemMenu.getAttribute('data-item').replace("\%", "");
      let ctnFeatured = "";
      let ctnFeaturedImage = "";
      if(itemId.split('--')[0] == "women"){
        ctnFeatured = document.querySelector(`#mujer .container-featured-collection`)
        ctnFeaturedImage = document.querySelector(`#mujer .container-featured-collection img`)
      }else{     
        ctnFeatured = document.querySelector(`#${itemId.split('--')[0]} .container-featured-collection`)
        ctnFeaturedImage = document.querySelector(`#${itemId.split('--')[0]} .container-featured-collection img`)
      }
      if(ctnFeatured && ctnFeaturedImage){
        ctnFeatured.style.opacity = 0;
        ctnFeatured.style.transition = 'none';
        ctnFeatured.querySelector('p').style.opacity = 0;
        ctnFeaturedImage.style.height = 0;
      }

      btnsAll.forEach(btnAll =>{
        btnAll.style.display = 'none';
      })
      showSubMenu(itemId, itemId.split('--')[0]);
      });
  });

  btnBack.forEach(btn => {
    btn.addEventListener('click', () => {
     
      menuBottom.style.display = 'grid';
      ctnFeatureCollection.forEach( ctn =>{ 
          ctn.style.opacity = 1;
          ctn.style.transition = 'opacity .5s ease-in'
          // ctn.style.display = 'block';
          ctn.querySelector('p').style.opacity = 1
      })
      imgFeatureCollection.forEach(img =>{
        img.style.height = '100%'
      })
      itemsMenu.forEach(itemMenu => {
        btnsAll.forEach(btnAll => btnAll.style.display = 'block')
        const itemId = itemMenu.getAttribute('data-item');
        hideSubMenu(itemId, itemId.split('--')[0]);
      });
    })
  })

});


  const showSubMenu = (subMenuId, menuId) => {
    const menusItem = document.querySelectorAll(`.${menuId}.menu-item`);
    const selecContry = document.querySelector('.selected_country_lenguage')
    menusItem.forEach(item => {
      item.classList.add('menu-item--active')
    })
    console.log("${subMenuId}", subMenuId)
    const subMenu = document.querySelector(`.sub-menu#${subMenuId}`);
    // subMenu.style.display = 'block';
    subMenu.classList.add('active')
    selecContry.classList.add('ocultar')
  }

  const hideSubMenu = (subMenuId, menuId) => {
    const menusItem = document.querySelectorAll(`.${menuId}.menu-item`);
    const selecContry = document.querySelector('.selected_country_lenguage')
    menusItem.forEach(item => {
      item.classList.remove('menu-item--active')
    })
    const subMenu = document.querySelector(`.sub-menu#${subMenuId}`);
    // subMenu.style.display = 'block';
    subMenu.classList.remove('active')
    selecContry.classList.remove('ocultar')
  }